export enum SaveTransactionAction {
  SaveAndStart = 'save-and-start',
  Save = 'save',
  Export = 'export',
}
